export const NODE_NAME = 'image';
